import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu/menu-trigger';
import * as moment from 'moment';
@Component({
  selector: 'input-periodo',
  templateUrl: './input-periodo.component.html',
  styleUrls: ['./input-periodo.component.scss']
})
export class InputPeriodoComponent implements OnInit, OnChanges {
  @ViewChild('nivelPrincipal') menuCalendario: MatMenuTrigger;
  @Input() reset: boolean;
  @Input() clase: '';
  @Input() inicio;
  @Input() fin;
  @Input() placeHolder = 'Periodo';
  @Output() emisor = new EventEmitter();
  catalogoPeriodo = ['Hoy', 'Ayer', 'Últimos 7 días', 'Últimos 30 días', 'Mes actual', 'Mes anterior'];
  fechaInicio: moment.Moment;
  fechaFin: moment.Moment;
  textoPeriodo = '';

  constructor() { }

  ngOnInit() {
    if (this.inicio && this.fin) {
      this.evento(moment(this.inicio).format('YYYY-MM-DD'), moment(this.fin).format('YYYY-MM-DD'), true);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    if (changes.reset && !changes.reset.firstChange) {
      if (!this.reset) {
        this.textoPeriodo = '';
      }

    }

  }
  onDateChanged(date) {
    // activar clase
  }
  evento(fechaInicio: string, fechaFin: string, sinEmitir?: boolean) {
    this.textoPeriodo = `${fechaInicio} a ${fechaFin}`;
    if (!sinEmitir) {
      const enviar = {
        fechaInicio,
        fechaFin,
      };
      this.emisor.emit(enviar);
    }
  }
  cerrarMenu() {
    this.menuCalendario.closeMenu();
  }

  periodo(opcionPeriodo: string) {
    switch (opcionPeriodo) {
      case 'Hoy':
        //this.evento(moment().format('DD-MM-YYYY'), moment().format('DD-MM-YYYY'));
        this.evento(moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'));
        break;
      case 'Ayer':
        this.evento(moment().subtract(1, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'days').format('YYYY-MM-DD'));
        break;
      case 'Últimos 7 días':
        this.evento(moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'));
        break;
      case 'Últimos 30 días':
        this.evento(moment().subtract(30, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'));
        break;
      case 'Mes actual':
        const mes = new Date().getMonth();
        const anio = new Date().getFullYear();
        const dias = moment(`${anio}-${mes + 1}`).daysInMonth();
        this.evento(moment(`${anio}/${mes + 1}/01`).format('YYYY-MM-DD'), moment(`${anio}/${mes + 1}/${dias}`).format('YYYY-MM-DD'));
        break;
      case 'Mes anterior':
        const unMesAntes = moment().subtract(1, 'months');
        const diasMesAnterior = moment(unMesAntes).daysInMonth();
        this.evento(moment(`${moment(unMesAntes).get('year')}/${moment(unMesAntes).get('month') + 1}/01`).format('YYYY-MM-DD'),
                    moment(`${moment(unMesAntes).get('year')}/${moment(unMesAntes).get('month') + 1}/${diasMesAnterior}`).format('YYYY-MM-DD'));
        break;
      case 'Personalizado':
        this.evento(moment(this.fechaInicio).format('YYYY-MM-DD'), moment(this.fechaFin).format('YYYY-MM-DD'));
        this.cerrarMenu();
        break;
      case 'Reset':
        this.evento(null, null);
        this.textoPeriodo = null;
        break;
      default:
        break;
    }
  }
}
